<template>
    <div :class="pageClass">
        <div :class="[`${pageClass}-header`]">
            <layout-header></layout-header>
        </div>
        <div :class="[`${pageClass}-main`]">
            <div :class="[`${pageClass}-main-content`]">
                <div :class="[`${pageClass}-main-content-box`]">
                    <div :class="[`${pageClass}-main-content-box-nav`]">
                        <div :class="[`${pageClass}-main-content-box-nav-user`]">
                            <img :src="avatar" />
                        </div>
                        <p class="name">{{ fullName }}</p>
                        <div :class="[`${pageClass}-main-content-box-nav-list`]">
                            <el-menu
                                router 
                                text-color="#5c307d"
                                active-text-color="#ffffff"
                                :default-active="$route.path"
                                class="el-menu-vertical-demo"
                            >
                            <!-- <el-menu-item index="/my-personal/my_evaluation">
                                <span slot="title">我的测评</span>
                            </el-menu-item>
                            <el-menu-item index="/my-personal/wrong_topic">
                                <span slot="title">错题本</span>
                            </el-menu-item>
                            <el-menu-item index="/my-personal/evaluation_record">
                                <span slot="title">测评记录</span>
                            </el-menu-item> -->
                            <el-menu-item index="/my-personal/setting">
                                <span slot="title">账号设置</span>
                            </el-menu-item>
                            <el-menu-item index="/my-personal/vip">
                                <span slot="title">我的已购</span>
                            </el-menu-item>
                            <el-menu-item index="/my-personal/active">
                                <span slot="title">激活</span>
                            </el-menu-item>
                            </el-menu>
                        </div>
                    </div>
                    <div :class="[`${pageClass}-main-content-box-right`]">
                        <router-view />
                    </div>
                </div>
            </div>
        </div>
        <div :class="[`${pageClass}-footer`]">
            <layout-footer></layout-footer>
        </div>
    </div>
</template>

<script>
import layoutHeader from '@/components/header/header'
import layoutFooter from '@/components/footer/footer'

export default {
    name : 'layout',
    data() {
        return {
            pageClass: 'layout',
            fullName: '',
            avatar: ''
        }
    },
    components:{
        layoutHeader,
        layoutFooter
    },
    created() {
        let user_json = localStorage.getItem('userinfo');
        const user = JSON.parse(user_json);
        this.fullName = user.nickname || user.fullName
        this.avatar = user.avatar
    },
    mounted() {
        this.$root.eventHub.$on('updata-user-info', () => {
            let user_json = localStorage.getItem('userinfo');
            const user = JSON.parse(user_json);
            this.fullName = user.nickname || user.fullName
            this.avatar = user.avatar
        })

        this.$root.eventHub.$on('updata-user-avatar', (avatar) => {
            this.avatar = avatar
        })
    }
}
</script>

<style lang="stylus" scoped>
    html, body {
        height:100%;
        margin:0;
        padding:0;
        overflow:hidden
    }
    .layout {
        height:100%;
        &-header {
            height: 72px;
            width:100%;
            position:absolute;
            z-index:5;
            top:0;
        }
        &-main {
            width:100%;
            overflow:auto;
            top: 72px;
            position: absolute;
            z-index: 10;
            bottom: 43px;
            background-color: #efefef;
            &-content {
                width: 1520px;
                height: 100%;
                margin: 0 auto;
                position: relative;
                &-box {
                    position: absolute;
                    top: 20px;
                    bottom: 20px;
                    left: 0;
                    right: 0;
                    z-index: 20;
                    display: flex;
                    &-nav {
                        width: 300px;
                        height: 100%;
                        background-color: #ffffff;
                        margin-right: 27px;

                        &-user {
                            width: 160px;
                            height: 160px;
                            border-radius: 100px;
                            overflow: hidden;
                            margin-top: 40px;
                            margin-left: 70px;
                            img {
                                width: 160px;
                                height: 160px;
                            }
                        }
                        &-list {
                            width: 100%;
                            margin-top: 30px;

                            /deep/ .el-menu-item {
                                left: 0px;
                                padding-left: 50px !important;
                                font-size 18px;
                            }

                            /deep/ .is-active {
                                background-color: #5c307d;
                            }
                        }
                        .name {
                            width: 270px;
                            height: 80px;
                            line-height: 80px;
                            text-align: center;
                            color: #585858;
                            margin: 0 auto;
                            font-size: 18px;
                            border-bottom: 2px solid #d2d2d2;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    &-right {
                        flex: 1;
                        background-color: #ffffff;
                        position: relative;
                    }
                }
            }
        }

        
        &-main::-webkit-scrollbar{
            width:0;
        }
        &-footer {
            height:43px;
            width:100%;
            position:absolute;
            z-index:200;
            bottom:0;
        }
    }
</style>